import React, { useMemo } from "react";
import CredoraIcon from "../Common/CredoraIcon";

/**
 * @typedef {Object} AccountingAction
 * @property {string} icon - CredoraIcon name
 * @property {string} label - Tooltip / aria-label
 * @property {() => void} onClick
 * @property {"default"|"primary"|"success"|"danger"} [variant]
 */

const AccountingIconActions = ({
  actions = [],
  onEdit,
  onDelete,
  editLabel = "Edit",
  deleteLabel = "Delete",
}) => {
  const resolvedActions = useMemo(() => {
    const list = [...actions];
    if (onEdit) list.push({ icon: "edit", label: editLabel, onClick: onEdit });
    if (onDelete) list.push({ icon: "trash", label: deleteLabel, onClick: onDelete, variant: "danger" });
    return list;
  }, [actions, onEdit, onDelete, editLabel, deleteLabel]);

  if (!resolvedActions.length) return null;

  return (
    <div className="credora-accounting-actions">
      {resolvedActions.map((action, index) => {
        const variant = action.variant || "default";
        return (
          <button
            key={`${action.label}-${index}`}
            type="button"
            className={`credora-accounting-actions__btn${
              variant !== "default" ? ` credora-accounting-actions__btn--${variant}` : ""
            }`}
            title={action.label}
            aria-label={action.label}
            onClick={action.onClick}
          >
            <CredoraIcon name={action.icon} size={15} />
          </button>
        );
      })}
    </div>
  );
};

export default AccountingIconActions;
